// extracted by mini-css-extract-plugin
export var button = "_lp-0";
export var donut = "_lp-1";
export var donutFill = "_lp-3";
export var donutTrack = "_lp-2";